<template>
    <div class="error-container">
      <h2>Error 101 - Me acabo de inventar este error</h2>
      <p>Esta página aún no la ha construido Gogo. Vuelve más tarde.</p>
      <img src="@/assets/sample_6fb0541f13aed64c6d18285c16570693.jpg" alt="Revisa la URL pndj" class="error-image" />
    </div>
    <AdSense />
  </template>
  
  <script>
  import AdSense from './AdSense.vue';
  export default {
    components: {
      AdSense
    }
  };
  </script>
  
  <style>
  /* Agrega aquí los estilos específicos */
  </style>